import {
    Directive,
    OnDestroy,
    TemplateRef,
    ViewContainerRef,
} from '@angular/core';
import { AppStateFacade } from '@app-state';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Directive({
    selector: '[uiRedrawOnLocaleChange]',
})
export class UiRedrawOnLocaleChangeDirective implements OnDestroy {
    private _templateRef: TemplateRef<void>;
    private _destroyed$ = new Subject();
    constructor(
        private _viewContainer: ViewContainerRef,
        appState: AppStateFacade,
        templateRef: TemplateRef<void>,
    ) {
        this._templateRef = templateRef;
        this._viewContainer.createEmbeddedView(this._templateRef);

        appState.language.change$
            .pipe(
                takeUntil(this._destroyed$),
            )
            .subscribe(() => {
                this._viewContainer.clear();
                this._viewContainer.createEmbeddedView(this._templateRef);
            });
    }

    ngOnDestroy() {
        this._destroyed$.next();
        this._destroyed$.complete();
    }
}
